import $ from "jquery/dist/jquery";

$(() => {
  function updateDeliveryPrices(changed = true) {
    let selected_dt = $('#deliveryTypes input[type="radio"]:checked');
    if (selected_dt.length > 0) {
      selected_dt = selected_dt.attr("rel");
    } else {
      selected_dt = null;
    }
    let selected_pt = $('#paymentTypes input[type="radio"]:checked');
    if (selected_pt.length > 0) {
      selected_pt = selected_pt.attr("rel");
    } else {
      selected_pt = null;
    }

    $("#deliveryTypes label").each(function () {
      let pricefield = $(this).closest(".paymentgroup").find(".price");
      let this_dt_id = parseInt($(this).attr("rel"));
      let min_price = null;
      let max_price = null;
      let diffs_by_zip_distance = false;
      for (const key in window.deliveryPrices[this_dt_id]) {
        const v = window.deliveryPrices[this_dt_id][key];

        if (min_price === null || min_price > v.price_delivery) {
          min_price = v.price_delivery;
        }
        if (max_price === null || max_price < v.price_delivery) {
          max_price = v.price_delivery;
        }
        if (v.diffs_by_zip_distance) {
          diffs_by_zip_distance = true;
        }
      }

      if (min_price <= 0) {
        pricefield.html(`<span class='free'>${window.NXMOD.TRANS_FREE}</span>`);
      } else if (min_price == max_price && !diffs_by_zip_distance) {
        pricefield.html(`${min_price}&nbsp;${window.NXMOD.CURRENCY_SYMBOL}`);
      } else {
        pricefield.html(`od ${min_price}&nbsp;${window.NXMOD.CURRENCY_SYMBOL}`);
      }
    });

    $("#paymentTypes input").each(function () {
      let pgroup = $(this).closest(".paymentgroup");
      let pricefield = $(this).closest(".paymentgroup").find(".price");
      let this_pt_id = parseInt($(this).attr("rel"));
      if (!selected_dt) {
        pgroup.addClass("disabled");
        $(this).attr("disabled", true);
        $(this).removeAttr("checked");
        pricefield.html("-");
      } else if (this_pt_id in window.deliveryPrices[selected_dt]) {
        pgroup.removeClass("disabled");
        $(this).attr("disabled", false);
        if (window.deliveryPrices[selected_dt][this_pt_id]["price_payment"] <= 0) {
          pricefield.html(`<span class='free'>${window.NXMOD.TRANS_FREE}</span>`);
        } else {
          pricefield.html(
            `${window.deliveryPrices[selected_dt][this_pt_id]["price_payment"]}&nbsp;${window.NXMOD.CURRENCY_SYMBOL}`,
          );
        }
      } else {
        pgroup.addClass("disabled");
        $(this).attr("disabled", true);
        $(this).removeAttr("checked");
        pricefield.html("-");
      }
    });

    selected_dt = $('#deliveryTypes input[type="radio"]:checked:enabled');
    let selected_dt_module = "";
    let selected_dt_data = null;
    if (selected_dt.length > 0) {
      selected_dt_module = selected_dt.attr("data-delivery-type-module");
      selected_dt_data = selected_dt.attr("data-delivery-type-module-data");
      selected_dt = selected_dt.attr("rel");
    } else {
      selected_dt = null;
    }
    selected_pt = $('#paymentTypes input[type="radio"]:checked:enabled');
    if (selected_pt.length > 0) {
      selected_pt = selected_pt.attr("rel");
    } else {
      selected_pt = null;
    }

    let dpid = null;
    if (selected_pt && selected_dt) {
      dpid = window.deliveryPrices[selected_dt][selected_pt]["type_id"];
    } else {
      dpid = null;
    }

    if (selected_dt_module != $("#deliveryTypes").data("old_selected_dt_module")) {
      $("#deliveryTypes").data("old_selected_dt_module", selected_dt_module);
      $(document).trigger("nxcms:deliveryTypeModuleSelected", {
        module: selected_dt_module,
        moduleData: selected_dt_data,
        deliveryTypeId: selected_dt,
      });
    }

    if (changed) {
      $.ajax({
        url: window.NXURLS.URL_ESHOP_CART_SELECT_DELIVERY,
        method: "POST",
        data: {
          delivery_price: dpid,
          delivery_additional_data: selected_dt_data,
        },
      })
        .done((data) => {
          $("#deliveryPriceContent").html(data.delivery_content);
          $("#deliveryPriceSummary").html(data.delivery_summary);
        })
        .fail(() => {
          window.NXCMS.toast("Nepovedlo se nastavit dopravu!", 4000);
          $("#deliveryPriceSummary").html("<p>Vyberte způsob dopravy a platby</p>");
        });
    } else {
      if ($("#deliveryPriceSummary").length) {
        $.ajax({
          url: window.NXURLS.URL_ESHOP_CART_SELECT_DELIVERY,
          method: "GET",
        })
          .done((data) => {
            $("#deliveryPriceContent").html(data.delivery_content);
            $("#deliveryPriceSummary").html(data.delivery_summary);
          })
          .fail(() => {
            $("#deliveryPriceSummary").html("<p>Vyberte způsob dopravy a platby</p>");
          });
      }
    }
  }
  $('#selectDeliveryType input[type="radio"]').change(updateDeliveryPrices);
  $('#selectDeliveryType #deliveryTypes input[type="radio"]').click(() => {
    let selected_dt = $('#deliveryTypes input[type="radio"]:checked:enabled');
    let selected_dt_module = "";
    let selected_dt_data = null;
    if (selected_dt.length > 0) {
      selected_dt_module = selected_dt.attr("data-delivery-type-module");
      selected_dt_data = selected_dt.attr("data-delivery-type-module-data");
      selected_dt = selected_dt.attr("rel");
    } else {
      selected_dt = null;
    }

    if (selected_dt_module) {
      $(document).trigger("nxcms:deliveryTypeModuleSelected", {
        module: selected_dt_module,
        moduleData: selected_dt_data,
        deliveryTypeId: selected_dt,
      });
    }
  });
  updateDeliveryPrices(false);
});
